import { render, staticRenderFns } from "./RelatoriosOperacionais.vue?vue&type=template&id=4f077459&scoped=true"
import script from "./RelatoriosOperacionais.vue?vue&type=script&lang=js"
export * from "./RelatoriosOperacionais.vue?vue&type=script&lang=js"
import style0 from "./RelatoriosOperacionais.vue?vue&type=style&index=0&id=4f077459&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f077459",
  null
  
)

export default component.exports